export default {
  filters: {},
  paginationOptions: {},
  employees: [],
  currentEmployee: {
    created_by: null,
    main_information: {},
    user: {},
    abacus_information: {},
    contacts: {},
    additional_information: {}
  }
};
